import { z } from 'zod';

export const languages = ['es'] as const;

export const defaultLanguage = 'es';

export const zTime = z.object({
	hours: z.number(),
	minutes: z.number(),
});

export const zInternationalization = z.object({
	es: z.string(),
});

export const dateFromString = z
	.string()
	.or(z.date())
	.transform((val, ctx) => {
		const date = new Date(val);
		if (isNaN(date.getTime())) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Invalid date string',
			});
			return z.NEVER;
		}
		return date;
	});
